<template>
  <div class="Index">
    
    <div class="page-margin1">
      <div class="index-swipe-wapper1">
        <div class="demo-swipe1 index-swipper1">
          <van-swipe @change="onChange"> 
            <van-swipe-item v-for="(image) in bannerList" :key="image.id">
              <img v-lazy="IP+image.image" />
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import ImagePreview from "vant";
// console.log('index');
import Vue from 'vue'
export default {
  props: ['JiashuBannerList'],
  name: 'MySwipe',
  components: {},
  data() {
    return {
      IP: Vue.prototype.IP,
      bannerList: this.JiashuBannerList,
      swipe_style: {
        backgroundColor: this.JiashuBannerList
          ? this.JiashuBannerList[0].theme_rgb
          : '#1a73e8',
      },
    }
  },
  methods: {
    onChange(index) {
      console.log('Current Swipe index:' + index)
    },
    picBanner() {
      console.log('picBanner')
    },
  },
}
</script>

